import { cloneImmutableArray } from './cloneImmutableArray';

export const arraySort = <T>(items: T[], compareFn?: (a: T, b: T) => number) => {
    return cloneImmutableArray(items).sort(compareFn);
};
